// 首次创建子账号申请

import ModalComponent from "@/components/ui/modal";
import { Text, Flex, Image } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { useMedia } from "@/hooks/useMedia";
import { BXButton } from "@/styles";

const ApplyPendingModal = ({ show, onOK, onCancel }) => {
  const { t } = useI18n();
  const { isMobile } = useMedia();

  return (
    <ModalComponent
      isShow={show}
      style={{ width: !isMobile ? "348px" : "calc(100% - 30px)" }}
    >
      <Flex
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        p={["30px 30px"]}
      >
        <Flex justifyContent={"space-between"} w={"100%"}>
          <Text fontSize={"16px"} fontWeight={500}>
            {t("IldgeERuYKVOefpR")}
          </Text>
          <Image
            src={"../../wwwsite/images/bill/close.svg"}
            cursor={"pointer"}
            onClick={() => {
              onCancel && onCancel();
            }}
          />
        </Flex>
        <Flex flexDirection={"column"} alignItems={"center"} mt={"20px"}>
          <Image src="../../wwwsite/images/kyc/certificate/pending.svg" />
          <Text fontSize={"24px"} mt={"10px"} fontWeight={600}>
            {t("KzFzOytWXScqDRKFwg")}
          </Text>
          <Text fontSize={"14px"} mt={"10px"}>
            {t("YXrqAGUqprWfOCeiSGX")}
          </Text>
        </Flex>

        <Flex justifyContent={"center"} mt={"30px"}>
          <BXButton
            className="cancel"
            w={["100%", "200px"]}
            onClick={() => {
              onOK && onOK();
            }}
          >
            {t("sYnLKnDJjNhHBCpTj")}
          </BXButton>
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default ApplyPendingModal;
